import { FilterTypeValue } from "@/components/filter/filter.types.ts";
import { FormParticipantStatusItems } from "@/types/forms/form.types.ts";
import { FilterItem, Multiselect } from "@skailer-com/uikit";
import { Control, Controller, FieldErrors } from "react-hook-form";
import { useTranslation } from "react-i18next";

export const FormParticipantStatusFilterRender = ({
  item,
  control,
  errors,
}: {
  item: FilterItem<FilterTypeValue>;
  control: Control;
  errors: FieldErrors;
}) => {
  const { t } = useTranslation();

  return (
    <Controller
      render={({ field: { value, onChange } }) => (
        <Multiselect
          label={t("common:status")}
          emptyTitle={t("common:select")}
          options={FormParticipantStatusItems()}
          values={value}
          onChange={onChange}
          isClearable
          error={errors[item.name]?.message as string}
        />
      )}
      control={control}
      name={item.name}
    />
  );
};
